import React from 'react';
const chips = ['No forms to fill', 'Refunded to your original payment method', 'Keep the bonuses'];
export function Guarantee() {
  return <section aria-labelledby="guarantee-heading" className="w-full bg-navy-deep" data-id="element-182" data-mp="1o3dmwcdeadr5">
      <div className="mx-auto max-w-3xl px-5 py-16 text-center sm:py-20" data-id="element-183" data-mp="2223ljwfv4lhm">
        <div className="mx-auto flex h-24 w-24 flex-col items-center justify-center rounded-full border-[3px] border-hl bg-hl/10 text-chalk" data-id="element-184" data-mp="1x42054uysa2z">
          <span className="font-display text-4xl font-bold leading-none" data-id="element-185" data-mp="19f0mn379y8qu">7</span>
          <span className="font-display text-xs font-bold uppercase tracking-widest" data-id="element-186" data-mp="14gz88vksmxlp">Days</span>
        </div>
        <p className="mt-6 text-[11px] font-semibold uppercase tracking-[1.6px] text-hl" data-id="element-187" data-mp="1j6554cw5sbqf">Zero risk</p>
        <h2 id="guarantee-heading" className="mt-3 font-display text-3xl text-chalk sm:text-5xl" data-id="element-188" data-mp="1eciyp2gl9432">
          Run your next practice from it.
        </h2>
        <p className="mx-auto mt-5 max-w-2xl text-base text-chalk/80" data-id="element-189" data-mp="lpoiwiupusvx">
          Open Volume 1, print Session 1.13 and run your first full carded
          practice. Try the Situation Finder and the Fence Station Sign Kit. If
          Track Coach Ready doesn&apos;t make your practices easier to plan and
          run, email us within 7 days and you get every cent back.
        </p>
        <ul className="mt-7 flex flex-wrap justify-center gap-2.5" data-id="element-190" data-mp="12qogm1m1qv6v">
          {chips.map(chip => <li key={chip} className="rounded-full border border-navy-line px-4 py-2 text-[13px] text-chalk/75" data-id="element-191" data-mp="60xat68b1llr">
              {chip}
            </li>)}
        </ul>
      </div>
    </section>;
}